import { render, staticRenderFns } from "./TaskRemovedFollowers.vue?vue&type=template&id=421dcfa2&scoped=true"
import script from "./TaskRemovedFollowers.vue?vue&type=script&lang=js"
export * from "./TaskRemovedFollowers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421dcfa2",
  null
  
)

export default component.exports